// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1r0Lu","containerItemsCenter":"Skeleton_containerItemsCenter__341sp"};